export interface userdetails {
    username: string,
    email: string,
    role: string,
    name:string,
    gender: string,
    active:boolean,
    uuid: string,
    avatar:string,
    password:string,
    passwordverification:string,
    activeMandant:string,
}

export interface mandantendetails {
    uuid: string,
    name: string,
    contact:string,
    customer:string,
}



export interface tableState {
    model:{
            user:userdetails,
            mandantenlist:mandantendetails[],
            listmandanten:mandantendetails[],
        }
    view:{
        loadeduuid: string,
        loaded: boolean, 
        autorefresh: boolean,
    }
}

export const InitialState = {
    model:{
        user:
            {
                username: "test",
                email: "test",
                role: "test",
                name:"test",
                gender: "test",
                active:false,
                uuid: "test",
                avatar:"images/avatar.jpg",
                password:"",
                passwordverification:"",
                activeMandant:"",
            },
        mandantenlist: [
                {
                    uuid: "aa",
                    name: "aaa",
                    contact:"aa",
                    customer:"aa",
                },
            ] as mandantendetails[],
            listmandanten: [
                {
                    uuid: "aa",
                    name: "aaa",
                    contact:"aa",
                    customer:"aa",
                },
            ] as mandantendetails[],
        }
        ,
        view:{
            loadeduuid :"",
            loaded: false,
            autorefresh: false,
        }
    }


export function deepCopyThingyState(toCopy:tableState):tableState{
    return {
        model:{
            user:{...toCopy.model.user},
            mandantenlist:toCopy.model.mandantenlist.map((mandantenlist) =>
            {
                return {
                    ...mandantenlist,
                }
            }),
            listmandanten:toCopy.model.listmandanten.map((listmandanten) =>
            {
                return {
                    ...listmandanten,
                }
            })
        },
    

        view:{
            loadeduuid:toCopy.view.loadeduuid,
            loaded:toCopy.view.loaded,
            autorefresh:toCopy.view.autorefresh
        }
    }
}

export function deepCopyThingyStateAndMerge(toCopy:tableState,FormData:any):tableState{
    const deepCopy = deepCopyThingyState(toCopy);

//    deepCopy.model.newuser = deepCopy.model.user[0];
    // console.log("FormData");
    
     if (FormData.type === "email")
         deepCopy.model.user.email = FormData.data
     if (FormData.type === "gender")
         deepCopy.model.user.gender = FormData.data
     if (FormData.type === "name")
         deepCopy.model.user.name = FormData.data
     if (FormData.type === "role")
         deepCopy.model.user.role = FormData.data
    if (FormData.type === "username")
        deepCopy.model.user.username = FormData.data
    if (FormData.type === "password")
        deepCopy.model.user.password= FormData.data
    if (FormData.type === "passwordverify")
        deepCopy.model.user.passwordverification = FormData.data
    return deepCopy;
}